<template>
    <div class="flex flex-col items-center gap-3">
        <div
            role="progressbar"
            :aria-label="label"
            :aria-valuenow="percentage"
            aria-valuemin="0"
            aria-valuemax="100"
            :aria-valuetext="message"
            class="overflow-hidden h-2 bg-accent-soft rounded-full mx-auto w-36 contextMeter">
            <div class="transition-[width] duration-300 h-2 rounded-full bg-accent" :style="{ width: `${percentage}%` }"></div>
        </div>
        <Transition name="fade" mode="out-in" appear>
            <div :key="message" class="min-h-6 body text-ink">{{ message }}</div>
        </Transition>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    percentage: { type: Number, default: 1 },
    ariaLabel: { type: String, default: undefined },
    currentCheckpoint: { type: Number, default: -1 },
    messageStack: { type: Array, default: undefined },
});

const label = computed(() => props.ariaLabel ?? t("onboarding.contextMeter.label"));
const defaultMessageStack = computed(() => [
    t("onboarding.contextMeter.promptMore"),
    t("onboarding.contextMeter.promptExamples"),
    t("onboarding.contextMeter.promptAnythingElse"),
    t("onboarding.contextMeter.promptExcellent"),
]);
const message = computed(() => (props.messageStack ?? defaultMessageStack.value)[props.currentCheckpoint] ?? "");
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 300ms ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
